import src from "IMAGE";
export default { src, width: 5760, height: 1792, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAKElEQVR42oXDsQ0AMAwCsBwQEAxs/H9nt66x5JmLJAP4d9ck3dZJ/AAfgAIPw780MwAAAABJRU5ErkJggg=="};
